import axios from "axios";
import React, { useEffect, useState } from "react";
import { firebaseConnect } from "react-redux-firebase";
import { Link } from "react-router-dom";
import { getViewport } from "../../utility/get-viewport";
import { Loading } from "../../utility/loading";
import ImageLoader from "../commons/image-loader";
import { NRCBalls, getCurrentVariationHOC } from "./utils";

export const ProductCard = (props) => {
  const currentVar = getCurrentVariationHOC(props);
  const images = currentVar?.images?.length ? currentVar.images : props.images;
  const hoverImage = props.hoverImage && props.hoverImage.length !== 0 ? props.hoverImage[0] : null

  const baseUrl = "/product/" + props.id;
  const variationParams =
    props.variates?.length > 0
      ? "?g=" +
        props.defaultVariationGroup +
        "&" +
        props.variates[props.defaultVariationGroup].list
          .map(
            (v) =>
              encodeURIComponent(v.id) +
              "=" +
              encodeURIComponent(props.variations[props.defaultVariationGroup].list._defaults[v.id])
          )
          .join("&")
      : "";

  const performanceSpecs = props.specs?.find(spec => spec.name.indexOf("Performance") !== -1)
  const installationSpecs = props.specs?.find(spec => spec.name.indexOf("Installation") !== -1)
  
  const functionality = performanceSpecs && performanceSpecs.list.find(specObj => specObj.specId === "functionality")?.spec || ''
  const absorptionFrequency = performanceSpecs && performanceSpecs.list.find(specObj => specObj.specId === "absorption-frequency")?.spec || ''
  const installation = installationSpecs && installationSpecs.list.find(specObj => specObj.specId === "place")?.spec || ''
  const nrc = performanceSpecs && performanceSpecs.list.find(specObj => specObj.specId === "nrc")?.spec || ''

  const hasNewFields = (
    (
      props.functionality
      || (absorptionFrequency && functionality)
    )
    || installation
    || props.fireClass
    || (props.nrcShort || nrc)
  )

  const oldDescription = (
    props.subCategories.includes('accessories')
    || props.subCategories.includes('insulation')
    || !hasNewFields
  )

  return (
    <Link className={`product-card ${props.discontinued ? 'discontinued' : ''} ${hoverImage ? 'has-hover' : ''}`} to={baseUrl + variationParams}>
      <div className="image-switcher">
        <ImageLoader
          shouldLoad={images && images.length > 0}
          enforceRatio
          source={images && images.length > 0
            ? getViewport(
              images[0].downloadURL,
              'm'
            )
            : ""
          }
          alt={props.name}
          imgProps={{ style: { objectFit: 'contain' } }}
          ratio={"4:3"}
        />
        {hoverImage && (
          <ImageLoader
            shouldLoad
            enforceRatio
            source={images && images.length > 0
              ? getViewport(
                hoverImage.downloadURL,
                'm'
              )
              : ""
            }
            alt={props.name}
            ratio={"4:3"}
          />
        )}
      </div>
      <h4 className="p" data-text-color="black" style={{ marginTop: '6px' }}>
        <b>{props.name}</b>
        {props.newProduct ? <>
          <b className="new-product-chip">NEW</b>
        </> : null}
        {props.discontinued ? <>
          <br />
          <b data-text-color="accent">(DISCONTINUED)</b>
        </> : null}
      </h4>
      {oldDescription
        ? <p className="small" style={{ marginTop: 0 }}>{props.shortSummary}</p>
        : (
          <p className="small" style={{ marginTop: 0 }}>
            {(props.functionality || (absorptionFrequency && functionality))
              ? <>
                <span>{props.functionality || `${absorptionFrequency} ${functionality}`}</span>
                <br />
              </>
              : null
            }
            {!props.functionality && (props.nrcShort || nrc) && <>
              <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                <span>NRC: {props.nrcShort || nrc}</span>
                <NRCBalls value={props.nrcClassification || 0} />
              </span>
              <br />
            </>}
            {props.absorptionMaterial && (<>
              <span>
                Absorbing Material: {props.absorptionMaterial}
                {new RegExp(/(VicPET Wool)|(High-density PET)/).test(props.absorptionMaterial) ? (
                  <i className="fas fa-leaf" title="Sustainable material" style={{ color: "#00ac54", marginLeft: '5px' }} />
                  ) : null}
              </span>
              <br />
            </>)}
            {props.fireClass && <>
              <span>Fire Class: {props.fireClass}</span>
              <br />
            </>}
            {installation && <>
              <span>Application: {installation}</span>
            </>}
          </p>
        )}
    </Link>
  );
};

const ProductWrapper = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [data, setData] = useState({});
  useEffect(() => {
    if (window.__SSRDATA && window.__SSRDATA[props.id]) {
      setData(window.__SSRDATA[props.id]);
      setIsLoading(false);
    }
    const getProduct = (headers) =>
      axios({
        method: "get",
        url:
          (props.byReference ? "/api/product-by-reference/" : "/api/product/") +
          props.id,
        headers: headers,
      });

    const getPrices = (user) =>
      (user
        ? user.getIdTokenResult(true).then((result) => {
            return getProduct({ Authorization: "Bearer " + result.token });
          })
        : getProduct({})
      )
        .then((result) => {
          setData(result.data);
          setIsLoading(false);
        })
        .catch((e) => {
          setHasError(true);
        });
    if (props.firebase.auth().currentUser) {
      getPrices(props.firebase.auth().currentUser);
    } else {
      return props.firebase.auth().onAuthStateChanged(getPrices);
    }
  }, [props.id]);
  return hasError ? null : isLoading ? (
    !props.hideLoading && <Loading />
  ) : (
    <ProductCard {...data} />
  );
};

export default firebaseConnect()(ProductWrapper);

// export default ProductWrapper;
